import React from "react";
import { useLang } from "../context/LanguageContext";
import { Instagram, Mail, MessageCircle, MapPin, ArrowUpRight } from "lucide-react";

const IG_URL = "https://www.instagram.com/salside.production";
const WA_URL = "https://wa.me/33627568937";
const EMAIL_URL = "mailto:salside.pro@gmail.com";

export default function Contact() {
  const { t } = useLang();
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#050505] py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-7">
            <p className="font-mono-tight text-zinc-500 mb-6">{t.contact.label}</p>
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-display tracking-tighter text-white" data-testid="contact-title">
              {t.contact.title}
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 flex items-end">
            <p className="text-zinc-400 text-base leading-relaxed" data-testid="contact-sub">{t.contact.sub}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 border-t border-white/10">
          <a
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-instagram-link"
            className="group p-8 md:p-10 border-b md:border-b-0 md:border-r border-white/10 hover:bg-white/[0.02] transition-colors flex flex-col"
          >
            <Instagram className="text-zinc-500 group-hover:text-white transition-colors mb-12" size={28} />
            <p className="font-mono-tight text-zinc-500 mb-3">{t.contact.ig}</p>
            <div className="flex items-center justify-between">
              <span className="text-2xl md:text-3xl text-white">@salside.production</span>
              <ArrowUpRight className="text-zinc-500 group-hover:text-white transition-colors" size={24} />
            </div>
          </a>
          <a
            href={WA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-link"
            className="group p-8 md:p-10 border-b md:border-b-0 md:border-r border-white/10 hover:bg-white/[0.02] transition-colors flex flex-col"
          >
            <MessageCircle className="text-zinc-500 group-hover:text-white transition-colors mb-12" size={28} />
            <p className="font-mono-tight text-zinc-500 mb-3">{t.contact.wa}</p>
            <div className="flex items-center justify-between">
              <span className="text-2xl md:text-3xl text-white">+33 6 27 56 89 37</span>
              <ArrowUpRight className="text-zinc-500 group-hover:text-white transition-colors" size={24} />
            </div>
          </a>
          <a
            href={EMAIL_URL}
            data-testid="contact-email-link"
            className="group p-8 md:p-10 hover:bg-white/[0.02] transition-colors flex flex-col"
          >
            <Mail className="text-zinc-500 group-hover:text-white transition-colors mb-12" size={28} />
            <p className="font-mono-tight text-zinc-500 mb-3">{t.contact.email}</p>
            <div className="flex items-center justify-between">
              <span className="text-2xl md:text-3xl text-white break-all">salside.pro@gmail.com</span>
              <ArrowUpRight className="text-zinc-500 group-hover:text-white transition-colors flex-shrink-0 ml-2" size={24} />
            </div>
          </a>
        </div>

        <div className="mt-16 flex items-center gap-3 font-mono-tight text-zinc-500" data-testid="contact-location">
          <MapPin size={14} />
          <span>{t.contact.paris}</span>
        </div>
      </div>
    </section>
  );
}
